module.exports = __webpack_public_path__ + "static/media/ic_replicate_btn.66adf13c.png";